import { render, staticRenderFns } from "./CheckmarkIcon.vue?vue&type=template&id=b2cfd3c8&"
import script from "./CheckmarkIcon.vue?vue&type=script&lang=ts&"
export * from "./CheckmarkIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CheckmarkIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports